import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useSelector } from "react-redux";
import ProfessionalAdminSettingsAsideBar from "./ProfessionalAdminSettingsAsideBar";
import { useGetUserDetailsQuery } from "../../../../../store/admin/professionalUserInfo";

const ProfessionalAdminSettingsLayout = ({ title, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { professionalId } = location?.state ?? {};
  const { data: professionaInfo } = useGetUserDetailsQuery(professionalId);
  const [showAsideBar, setShowAsideBar] = useState(false);

  const isMobile =
    window.matchMedia &&
    window.matchMedia("only screen and (max-width: 767px)").matches;

  const handleGoBack = () => {
    isMobile ? setShowAsideBar(true) : navigate(-1);
  };

  return (
    <div className="col-span-12">
      <div className="">
        <div className="mb-7 flex md:items-center gap-1.5 md:gap-2.5 flex-col md:flex-row">
          <div className="flex items-center gap-[6px] xl:gap-[10px]">
            <div className="flex items-center gap-[10px]">
              <ArrowLeftIcon
                className="w-6 h-6 text-[#485868] cursor-pointer"
                onClick={handleGoBack}
              />
              <h3
                className="hidden md:block text-xl xl:text-2xl font-normal leading-[130%] text-[#485868] cursor-pointer"
                onClick={handleGoBack}
              >
                Professional
              </h3>
            </div>
            <span className="hidden md:block text-[#485868]">&#8226;</span>
            <h3 className="md:block text-xl xl:text-2xl font-normal leading-[130%] text-[#485868] cursor-pointer">
              {professionaInfo?.data?.first_name}{" "}
              {professionaInfo?.data?.last_name}
            </h3>
            <span className="text-[#485868]">&#8226;</span>
            <h4 className="text-xl md:text-2xl font-bold leading-[130%] md:leading-[130%] text-[#04091E]">
              Settings
            </h4>
          </div>
          <span className="font-normal leading-[130%] text-[#EF2121]">
            (You are editing {professionaInfo?.data?.first_name}{" "}
            {professionaInfo?.data?.last_name} user profile)
          </span>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-6">
        <div className="col-span-12 md:col-span-4 xl:col-span-3">
          {isMobile && showAsideBar ? (
            <ProfessionalAdminSettingsAsideBar
              setShowAsideBar={setShowAsideBar}
            />
          ) : (
            !isMobile && (
              <ProfessionalAdminSettingsAsideBar setShowAsideBar={() => {}} />
            )
          )}
        </div>
        <div className="col-span-12 md:col-span-8 xl:col-span-9">
          {!showAsideBar && children}
        </div>
      </div>
    </div>
  );
};

export default ProfessionalAdminSettingsLayout;
